const CONFIG_KEY = "abaninja_config";
const STORAGE_VERSION = "1.0";

// GEÄNDERT: Verschiedene Optionen für Speicherdauer
const MAX_AGE_OPTIONS = {
  SHORT: 8 * 60 * 60 * 1000,      // 8 Stunden (aktuell)
  MEDIUM: 24 * 60 * 60 * 1000,    // 1 Tag
  LONG: 7 * 24 * 60 * 60 * 1000,  // 1 Woche
  VERY_LONG: 30 * 24 * 60 * 60 * 1000, // 1 Monat
  PERMANENT: null                   // Nie ablaufen (nicht empfohlen für Tokens)
};

// WÄHLEN SIE HIER DIE GEWÜNSCHTE DAUER:
const MAX_AGE = MAX_AGE_OPTIONS.PERMANENT; // 1 Woche

// Alternativ: localStorage statt sessionStorage für längere Speicherung
const USE_LOCAL_STORAGE = true; // false = sessionStorage (nur Browser-Sitzung)

const storage = USE_LOCAL_STORAGE ? localStorage : sessionStorage;

// Einfache Verschlüsselung (in Production durch echte Crypto-Lib ersetzen)
const encryptData = (data) => {
  try {
    const payload = {
      version: STORAGE_VERSION,
      timestamp: Date.now(),
      data: data,
    };
    return btoa(JSON.stringify(payload));
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

const decryptData = (encrypted) => {
  try {
    if (!encrypted) return null;
    const payload = JSON.parse(atob(encrypted));

    // Version validieren
    if (payload.version !== STORAGE_VERSION) {
      console.warn("Config version mismatch - clearing storage");
      return null;
    }

    // Alter prüfen (nur wenn MAX_AGE gesetzt ist)
    if (MAX_AGE && Date.now() - payload.timestamp > MAX_AGE) {
      console.warn("Config expired - clearing storage");
      return null;
    }

    return payload.data;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

// UUID-Validierung
const validateUUID = (uuid) => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

// Bearer Token Validierung (grundlegend)
const validateBearerToken = (token) => {
  if (!token || typeof token !== "string") return false;
  if (token.length < 50) return false; // Mindestlänge
  // JWT-Format prüfen (optional)
  const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
  return jwtRegex.test(token);
};

// Config validieren
const validateConfig = (config) => {
  if (!config || typeof config !== "object") {
    throw new Error("Config must be an object");
  }
  if (!config.accountUuid || !validateUUID(config.accountUuid)) {
    throw new Error("Invalid or missing Account UUID");
  }

  if (!config.bearerToken || !validateBearerToken(config.bearerToken)) {
    throw new Error("Invalid or missing Bearer Token");
  }

  return true;
};

// Hauptfunktionen
export const saveSecureConfig = (config) => {
  try {
    // Validierung vor dem Speichern
    validateConfig(config);
    const encrypted = encryptData(config);
    if (!encrypted) {
      throw new Error("Encryption failed");
    }

    storage.setItem(CONFIG_KEY, encrypted);
    return true;
  } catch (error) {
    storage.removeItem(CONFIG_KEY);
    throw error;
  }
};

export const loadSecureConfig = () => {
  try {
    const encrypted = storage.getItem(CONFIG_KEY);
    const config = decryptData(encrypted);
    if (!config) {
      // Storage löschen wenn ungültig
      storage.removeItem(CONFIG_KEY);
      return { accountUuid: "", bearerToken: "" };
    }

    // Nochmal validieren nach dem Laden
    validateConfig(config);
    return config;
  } catch (error) {
    console.warn("Failed to load config:", error.message);
    storage.removeItem(CONFIG_KEY);
    return { accountUuid: "", bearerToken: "" };
  }
};

export const clearSecureConfig = () => {
  storage.removeItem(CONFIG_KEY);
};

// Session-Status prüfen
export const isConfigExpired = () => {
  if (!MAX_AGE) return false; // Nie ablaufen wenn MAX_AGE = null
  
  const encrypted = storage.getItem(CONFIG_KEY);
  if (!encrypted) return true;
  try {
    const payload = JSON.parse(atob(encrypted));
    return Date.now() - payload.timestamp > MAX_AGE;
  } catch {
    return true;
  }
};

// NEU: Info über aktuelle Einstellungen
export const getStorageInfo = () => {
  return {
    storageType: USE_LOCAL_STORAGE ? 'localStorage' : 'sessionStorage',
    maxAge: MAX_AGE,
    maxAgeHuman: MAX_AGE ? `${Math.floor(MAX_AGE / (1000 * 60 * 60))} Stunden` : 'Permanent'
  };
};